<div class="out" #out>
  <line-width class="slider"></line-width>
</div>
